import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import { KOALA, OBSIDIAN } from 'HubStyleTokens/colors';
import { MERCURY_LAYER } from 'HubStyleTokens/sizes';
const StyledMobilePanelFooter = styled(UIDialogFooter).withConfig({
  displayName: "MobilePanelFooter__StyledMobilePanelFooter",
  componentId: "yg52s0-0"
})(["background-color:", ";border-top:1px solid ", ";z-index:", ";"], OBSIDIAN, KOALA, MERCURY_LAYER);
StyledMobilePanelFooter.displayName = 'StyledMobilePanelFooter';
export default function MobilePanelFooter(props) {
  return /*#__PURE__*/_jsx(StyledMobilePanelFooter, Object.assign({}, props));
}